import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
/**
 * "添加商品列表"相关操作
 */
export default {
  methods: {
    /**
     * 单个删除/批量删除商品
     *
     * 使用页面:
     * - 新建/编辑新着情报页面 src/pages/articlemanagement/NewsManagement/NewsDetail.vue
     * - 新建/编辑活动页面 目前该页面并未引用此方法，是页面中单独现实的删除商品逻辑，并且删除当前页商品时有bug，今后需要改为引用本方法来修复问题
     *
     * @param record 当前行数据，根据此参数判断是单个删除还是批量删除
     */
    removeErpCustomers: function removeErpCustomers(record) {
      // 存储要删除的商品
      var deleteData = [];
      // 单个删除
      if (record) {
        deleteData = [record];
      } else {
        // 批量删除
        switch (this.modalValue.removeType) {
          // 删除选中的商品
          case 0:
            deleteData = this.selectProductList;
            break;
          // 删除当前页的商品
          case 1:
            deleteData = this.crrentPageProductList;
            break;
          // 删除全部商品
          case 2:
            deleteData = this.formData.productList;
            break;
          default:
            return;
        }
      }
      // 获取要删除的商品的optionId
      var deleteIds = deleteData.map(function (item) {
        return item.optionId;
      });
      // 将要删除的商品从商品列表中移除
      var filterByDeleteIds = function filterByDeleteIds(item) {
        return !deleteIds.includes(item.optionId || item);
      };
      // 移除全部商品列表中要删除的商品
      this.formData.productList = this.formData.productList.filter(filterByDeleteIds);
      // 移除选中商品列表中要删除的商品
      this.selectProductList = this.selectProductList.filter(filterByDeleteIds);
      // 移除选中商品optionId列表中要删除的商品, 用于维护table中的选中状态
      this.selectedRowKeys = this.selectedRowKeys.filter(filterByDeleteIds);
      // 移除全部商品optionId列表中要删除的商品，用于维护选择商品弹窗中的选中状态
      this.productOptionIdList = this.productOptionIdList.filter(filterByDeleteIds);
      // 删除商品后需要重新获取当前页商品列表，否则无法连续删除
      this.queryParam.page = parseInt(this.formData.productList.length / this.queryParam.size);
      this.calcCurrentPageProductList();
    }
  }
};